import { render } from "./FeatureTile.vue?vue&type=template&id=45f8bc1e&scoped=true"
import script from "./FeatureTile.vue?vue&type=script&lang=js"
export * from "./FeatureTile.vue?vue&type=script&lang=js"

import "./FeatureTile.vue?vue&type=style&index=0&id=45f8bc1e&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f8bc1e"]])

export default __exports__